import { allSignals, isSequential, observableSignalKeys } from "./registry";
import { eventTimes, inputValue, clockValue } from "./simulator";
import { randomizeInputs } from "./generator";
import { clone } from "../utils/projects";
export function primaryInputs(project) {
  return project.inputs.filter((i) =>
    project.connections.some((e) => e.from.input === i.id),
  );
}
export function prepareTiming(project, cycles = 8, seed) {
  const p = clone(project),
    clock = p.components.find((c) => c.type === "CLOCK"),
    period = clock?.config.period || 2;
  p.timing = {
    ...p.timing,
    cycles,
    duration: cycles * period,
    step: period / 2,
    showTerminals: true,
    prepared: true,
  };
  if (seed !== undefined) randomizeInputs(p, String(seed));
  else
    p.inputs.forEach((input) => {
      if (!input.events)
        input.values = Array.from(
          { length: cycles * 2 },
          (_, i) => input.values[i] ?? input.values.at(-1) ?? 0,
        );
    });
  const order = p.components
    .filter((c) => c.type === "CLOCK")
    .map((c) => `${c.id}:CLK`);
  order.push(...primaryInputs(p).map((i) => `input:${i.id}`));
  p.components.filter(isSequential).forEach((c) => {
    order.push(
      ...allSignals(p)
        .filter((s) => s.terminal && s.component === c.id)
        .map((s) => s.id),
      `${c.id}:Q`,
      `${c.id}:Qn`,
    );
  });
  p.timing.order = order;
  return p;
}
export function givenResult(project) {
  const times = eventTimes(project),
    signals = allSignals(project);
  return {
    duration: project.timing.duration,
    times,
    signals,
    trace: [],
    warnings: [],
    samples: times.slice(0, -1).map((time) => {
      const values = { "const:0": 0, "const:1": 1, "const:X": "X" };
      project.inputs.forEach(
        (i) =>
          (values[`input:${i.id}`] = inputValue(i, time, project.timing.step)),
      );
      project.components.forEach((c) => {
        if (c.type === "CLOCK") values[`${c.id}:CLK`] = clockValue(c, time);
        if (c.type.startsWith("CONST"))
          values[`${c.id}:Y`] = c.type === "CONST1" ? 1 : 0;
      });
      return { time, values };
    }),
  };
}
export function simulatorRows(project, result) {
  const observed = observableSignalKeys(project),
    order = project.timing.order || [],
    usedInputs = new Set(primaryInputs(project).map((i) => `input:${i.id}`));
  const rows = result.signals
    .filter((s) => {
      if (s.source?.input && !s.terminal) return usedInputs.has(s.id);
      if (s.terminal) return project.timing.showTerminals !== false;
      return s.given || observed.has(s.id);
    })
    .filter((s) => !(project.timing.hidden || []).includes(s.id))
    .map((s) => ({ ...s, name: project.timing.aliases?.[s.id] || s.name }));
  return rows.sort(
    (a, b) =>
      (order.includes(a.id) ? order.indexOf(a.id) : 1e5) -
      (order.includes(b.id) ? order.indexOf(b.id) : 1e5),
  );
}
